export var TextAlign;
(function (TextAlign) {
    TextAlign["Left"] = "left";
    TextAlign["Right"] = "right";
    TextAlign["Center"] = "center";
    TextAlign["Justify"] = "justify";
})(TextAlign || (TextAlign = {}));
export var TextSizing;
(function (TextSizing) {
    TextSizing["Absolute"] = "absolute";
    TextSizing["Auto"] = "auto";
})(TextSizing || (TextSizing = {}));
export var TextUnit;
(function (TextUnit) {
    TextUnit["Pixel"] = "px";
    TextUnit["Percent"] = "%";
})(TextUnit || (TextUnit = {}));
export var TextDecorationTypes;
(function (TextDecorationTypes) {
    TextDecorationTypes["None"] = "none";
    TextDecorationTypes["Strikethrough"] = "strikethrough";
    TextDecorationTypes["Underline"] = "underline";
})(TextDecorationTypes || (TextDecorationTypes = {}));
